export default __webpack_public_path__ + "static/media/kitchen-pack-13.ded1183a.png";